import { CourseContent, LucideIconName } from '@bm-js/atlascloud-shared'

import { v4 as uuid } from 'uuid'

export const courseContentTypes: CourseContent[] = [
  {
    type: 'header',
    name: 'Rubrik',
    icon: LucideIconName.CaseSensitive,
    uuid: uuid(),
    data: {
      text: '',
    },
  },

  {
    type: 'richtext',
    name: 'Brödtext',
    icon: LucideIconName.TextAlignStart,
    uuid: uuid(),
    data: {
      html: '',
    },
  },
  {
    type: 'image',
    name: 'Bild',
    icon: LucideIconName.Image,
    uuid: uuid(),
    data: {
      file: {},
    },
  },
  {
    type: 'ytvideo',
    name: 'YouTube-video',
    icon: LucideIconName.Film,
    uuid: uuid(),
    data: {
      fullLink: '',
      id: '',
      embedLink: '',
    },
  },
  {
    type: 'document',
    name: 'Dokument',
    icon: LucideIconName.FileText,
    uuid: uuid(),
    data: {
      file: {},
    },
  },
]
